/**
 * Header controls.
 */
import { debounce } from '../utils/drawing';
export default function headerSection() {

  // Navigation buttons and clicks
  const navi = document.getElementById('headerMenu');
  const naviButton = document.getElementById('headerMenuButton');
  const naviCloseButton = document.querySelectorAll('.header-menu-banner button');
  const fader = document.getElementById('fader');

  const menuToggle = event => {

    navi.classList.toggle('open');
    navi.classList.toggle('closed');
    fader.classList.toggle('open');
    fader.classList.toggle('closed');

    document.body.classList.toggle('locked');

    event.stopImmediatePropagation();
    event.preventDefault();
  };

  naviButton.addEventListener('click', menuToggle);
  naviCloseButton.forEach(button => { 
    button.addEventListener('click', event => {
      menuToggle();
    });  
  });

  navi.addEventListener('click', event => {
    event.stopImmediatePropagation();
  });

  document.body.addEventListener('click', event => {
    if (navi.classList.contains('open')) menuToggle(event);
  });

  // Sub menu expansion
  document.querySelectorAll('#headerMenu ul.top li.parent > a').forEach(link => {
    link.addEventListener('click', event => {
      if (link.parentNode.classList.contains('minimised')) {
        link.parentNode.classList.replace('minimised', 'expanded');
      } else {
        link.parentNode.classList.replace('expanded', 'minimised');
      }

      event.preventDefault();
    });
  });

  // Scroll header
  let scrollWatch = false;
  let previousScrollTop = 0;
  window.addEventListener('scroll', debounce(() => {
    
    const scrollThreshold = 220;
    const headerElement = document.getElementById('header');

    let newScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (newScrollTop > previousScrollTop) {
      if (!scrollWatch) {
      
        if (newScrollTop > scrollThreshold) {
          
          // add header buffer
          document.getElementById('content').classList.add('header-buffer');
          
          // make the header float
          headerElement.classList.add('header-float');
          headerElement.classList.remove('open');
          headerElement.classList.add('closed');

          scrollWatch = true;
        }
      }
    } else { 
      if (scrollWatch) {

        // show the header
        headerElement.classList.remove('closed');
        headerElement.classList.add('open');
        scrollWatch = false;
      }

      if (newScrollTop === 0) {

        // remove header buffer
        document.getElementById('content').classList.remove('header-buffer');

        // remove all float classes
        headerElement.classList.remove('header-float');
        headerElement.classList.remove('open');
        headerElement.classList.remove('closed');
      }

    }
    previousScrollTop = newScrollTop <= 0 ? 0 : newScrollTop; // for mobile or negative scrolling
  }));
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js